export const USER_ROLE_ANONYMOUS = 'anonymous';
export const USER_ROLE_RENTER = 'renter';
export const USER_ROLE_ADMIN = 'admin';
export const USER_ROLE_AGENT = 'agent';
export const USER_ROLE_BUYER_SIDE_AGENT = 'buyerSideAgent';
export const USER_ROLE_LANDLORD = 'landlord';
export const USER_ROLE_APARTMENT_LOCATOR = 'apartmentLocator';
export const USER_ROLE_HOUSEHOLD_ADMIN = 'householdAdmin';
export const USER_ROLE_SUNROOM_CLUB = 'sunroomClub';
export const USER_ROLE_PARTNER = 'partner';
export const USER_ROLE_PROPERTY_MANAGER = 'propertyManager';
export const USER_ROLE_FIELD_OPS = 'fieldOps';
export const USER_ROLE_LIMITED_TOURS = 'limitedTours';
export const USER_ROLE_SHADOW_BANNED = 'shadowBanned';
export const USER_ROLE_SELF_SHOWING_TESTER = 'selfShowingTester';
export const USER_ROLE_ACCOUNT_MANAGER = 'accountManager';
export const USER_ROLE_SALES_REP = 'salesRep';
export const USER_ROLE_PRESEVE_ON_DEV = 'preserveOnDev';
export const USER_ROLE_LISTING_REVIEWER = 'listingReviewer';
export const USER_ROLE_PHOTOGRAPHER = 'photographer';
export const USER_ROLE_DRIVER = 'driver';

export const ALL_USER_ROLES = [
  USER_ROLE_RENTER,
  USER_ROLE_ADMIN,
  USER_ROLE_AGENT,
  USER_ROLE_BUYER_SIDE_AGENT,
  USER_ROLE_LANDLORD,
  USER_ROLE_APARTMENT_LOCATOR,
  USER_ROLE_HOUSEHOLD_ADMIN,
  USER_ROLE_SUNROOM_CLUB,
  USER_ROLE_FIELD_OPS,
  USER_ROLE_LIMITED_TOURS,
  USER_ROLE_PARTNER,
  USER_ROLE_PROPERTY_MANAGER,
  USER_ROLE_SHADOW_BANNED,
  USER_ROLE_SELF_SHOWING_TESTER,
  USER_ROLE_ACCOUNT_MANAGER,
  USER_ROLE_SALES_REP,
  USER_ROLE_PRESEVE_ON_DEV,
  USER_ROLE_LISTING_REVIEWER,
  USER_ROLE_PHOTOGRAPHER,
  USER_ROLE_DRIVER,
];

export const SR_STAFF_USER_ROLES = [
  USER_ROLE_ADMIN,
  USER_ROLE_AGENT,
  USER_ROLE_APARTMENT_LOCATOR,
  USER_ROLE_HOUSEHOLD_ADMIN,
  USER_ROLE_FIELD_OPS,
  USER_ROLE_SELF_SHOWING_TESTER,
  USER_ROLE_ACCOUNT_MANAGER,
  USER_ROLE_SALES_REP,
  USER_ROLE_LISTING_REVIEWER,
  USER_ROLE_PHOTOGRAPHER,
  USER_ROLE_DRIVER,
];

export const SR_USER_GROUP_ROLE_PARTNER = [
  USER_ROLE_ADMIN,
  USER_ROLE_PARTNER,
  USER_ROLE_PROPERTY_MANAGER,
  USER_ROLE_LANDLORD,
];

export const hasRoleAnonymous = (userRoles) => {
  return userRoles.includes(USER_ROLE_ANONYMOUS);
};

export const hasRoleRenter = (userRoles) => {
  return userRoles.includes(USER_ROLE_RENTER);
};

export const hasRoleApartmentLocator = (userRoles) => {
  return userRoles.includes(USER_ROLE_APARTMENT_LOCATOR);
};

export const hasRoleAgent = (userRoles) => {
  return userRoles.includes(USER_ROLE_AGENT);
};

export const hasRoleBuyerSideAgent = (userRoles) => {
  return userRoles.includes(USER_ROLE_BUYER_SIDE_AGENT);
};

export const hasRoleAdmin = (userRoles) => {
  return userRoles.includes(USER_ROLE_ADMIN);
};

export const hasRoleHouseholdAdmin = (userRoles) => {
  return userRoles.includes(USER_ROLE_HOUSEHOLD_ADMIN);
};

export const hasRoleSunroomClub = (userRoles) => {
  return userRoles.includes(USER_ROLE_SUNROOM_CLUB);
};

export const hasRolePartner = (userRoles) => {
  return userRoles.includes(USER_ROLE_PARTNER);
};

export const hasRolePropertyManager = (userRoles) => {
  return userRoles.includes(USER_ROLE_PROPERTY_MANAGER);
};

export const hasRoleLandlord = (userRoles) => {
  return userRoles.includes(USER_ROLE_LANDLORD);
};

export const hasRoleFieldOps = (userRoles) => {
  return userRoles.includes(USER_ROLE_FIELD_OPS);
};

export const hasRoleDriver = (userRoles) => {
  return userRoles.includes(USER_ROLE_DRIVER);
};

export const hasRoleLimitedTours = (userRoles) => {
  return userRoles.includes(USER_ROLE_LIMITED_TOURS);
};

export const hasRoleShadowBanned = (userRoles) => {
  return userRoles.includes(USER_ROLE_SHADOW_BANNED);
};

export const hasRoleSelfShowingTester = (userRoles) => {
  return userRoles.includes(USER_ROLE_SELF_SHOWING_TESTER);
};

export const hasRoleForSrStaff = (userRoles) => {
  return userRoles.some((userRole) => SR_STAFF_USER_ROLES.includes(userRole));
};

export const hasRoleForGroupPartner = (userRoles) => {
  return userRoles.some((userRole) => SR_USER_GROUP_ROLE_PARTNER.includes(userRole));
};

export const hasRoleListingReviewer = (userRoles) => {
  return userRoles.includes(USER_ROLE_LISTING_REVIEWER);
};

export const hasRolePhotographer = (userRoles) => {
  return userRoles.includes(USER_ROLE_PHOTOGRAPHER);
};
